/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

export enum DraggableBlockTypes {
  BLOCK = "BLOCK",
  NATIVE_FILE = "__NATIVE_FILE__", // Yucky copypasta of NativeTypes.FILE; Can't reference computed value in enum: https://github.com/microsoft/TypeScript/issues/40793
}
